var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"backtopBox",style:({
      width: _vm.width,
      display: _vm.display,
      width: _vm.width + 'px',
      height: _vm.height + 'px',
      bottom: _vm.bottom + 'px',
      right: _vm.right + 'px',
      color: _vm.color,
    }),on:{"click":function($event){return _vm.toTop()}}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbox"},[_c('img',{staticStyle:{"padding-top":"10px","padding-left":"10px","width":"80%"},attrs:{"src":require("@/assets/fanhuidingbu.png"),"alt":"返回顶部"}})])
}]

export { render, staticRenderFns }